import { render, staticRenderFns } from "./leaderInfoCell.vue?vue&type=template&id=03018cef"
import script from "./leaderInfoCell.vue?vue&type=script&lang=js"
export * from "./leaderInfoCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports